import InactivityModal from '@/components/InactivityModal.vue';

export const inactivityMixin = {
  components: {
    InactivityModal
  },
  
  data() {
    return {
      // Настройки неактивности
      inactivityTimeout: 2 * 60 * 1000, // 2 минуты в миллисекундах
      showInactivityModal: false,
      
      // Отслеживание времени скрытия вкладки
      tabHiddenTime: null,
      isTabVisible: !document.hidden, // Правильно определяем начальное состояние
      hasBeenHidden: false // Флаг, что вкладка была скрыта хотя бы раз
    };
  },
  
  mounted() {
    this.initInactivityTracking();
  },
  
  beforeDestroy() {
    this.cleanupInactivityTracking();
  },
  
  methods: {
    // Инициализация отслеживания неактивности
    initInactivityTracking() {
      // Отслеживание видимости вкладки
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
    },
    
    // Очистка event listeners
    cleanupInactivityTracking() {
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    },
    
    // Проверка, является ли пользователь отделом контроля
    isControlDepartment() {
      // Получаем роль из store или computed свойства компонента
      const role = this.userRole || (this.$store && this.$store.state.user && this.$store.state.user.role);
      if (!role) return false;
      const roleStr = String(role).toLowerCase();
      return roleStr.includes('контрол');
    },
    
    // Обработка изменения видимости вкладки
    handleVisibilityChange() {
      // Пропускаем проверку бездействия для отдела контроля
      if (this.isControlDepartment()) {
        return;
      }
      
      if (document.hidden) {
        // Вкладка стала скрытой - запоминаем время
        this.isTabVisible = false;
        this.hasBeenHidden = true; // Отмечаем, что вкладка была скрыта
        this.tabHiddenTime = Date.now();
        console.log('Вкладка скрыта в:', new Date(this.tabHiddenTime));
      } else {
        // Вкладка стала видимой
        this.isTabVisible = true;
        
        // Проверяем модальное окно только если вкладка была скрыта И есть время скрытия
        if (this.hasBeenHidden && this.tabHiddenTime) {
          const hiddenDuration = Date.now() - this.tabHiddenTime;
          console.log('Вкладка была скрыта:', hiddenDuration / 1000, 'секунд');
          
          // Если вкладка была скрыта больше 2 минут - показываем модальное окно
          if (hiddenDuration >= this.inactivityTimeout) {
            console.log('Показываем модальное окно неактивности');
            this.showInactivityModal = true;
          }
          
          // Сбрасываем время скрытия
          this.tabHiddenTime = null;
        } else if (!this.hasBeenHidden) {
          console.log('Вкладка стала видимой, но еще не была скрыта - игнорируем');
        }
      }
    },
    
    // Обработка события "продолжить работу"
    handleContinueWork() {
      this.showInactivityModal = false;
      console.log('Пользователь выбрал продолжить работу');
    },
    
    // Обработка события "закрыть заказ"
    handleCloseOrder() {
      this.showInactivityModal = false;
      console.log('Пользователь выбрал закрыть заказ');
      
      // Переходим на страницу со списком заказов
      this.$router.push('/orders');
    },
    
    // Закрытие модального окна
    closeInactivityModal() {
      this.showInactivityModal = false;
      console.log('Модальное окно закрыто');
    }
  }
}; 